import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CanDeactivateGuard } from '@egovsolutions/angular-can-deactivate-guard';
import { LookupComponent } from './pages/lookup/lookup.component';


export const routes: Routes = [
    {
        path: '',
        data: { title: 'Tax Lookup' },
        component: LookupComponent,
        children:
        [
            {
                path: ':tax',
                component: LookupComponent,
                children:
                [
                    {
                        path: ':query',
                        component: LookupComponent,
                        children:
                        [
                            {
                                path: ':sort/:direction',
                                component: LookupComponent,
                                canDeactivate: [CanDeactivateGuard],
                                resolve: { forceRepaint: 'forceRepaintResolver' },
                            },
                        ],
                        canDeactivate: [CanDeactivateGuard],
                        resolve: { forceRepaint: 'forceRepaintResolver' },
                    },
                ],
                canDeactivate: [CanDeactivateGuard],
                resolve: { forceRepaint: 'forceRepaintResolver' },
            },
        ],
        canDeactivate: [CanDeactivateGuard],
        resolve: { forceRepaint: 'forceRepaintResolver' },
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class LookupRoutingModule { }
